export const PASSAVIA_GLOBAL_CHAT_OPEN_EVENT = 'passavia:global-chat:open'

export function openPassaviaGlobalChat(): void {
  window.dispatchEvent(new Event(PASSAVIA_GLOBAL_CHAT_OPEN_EVENT))
}
